import { render, staticRenderFns } from "./MUITHome.vue?vue&type=template&id=2e66eb13&scoped=true"
import script from "./MUITHome.vue?vue&type=script&lang=js"
export * from "./MUITHome.vue?vue&type=script&lang=js"
import style0 from "./MUITHome.vue?vue&type=style&index=0&id=2e66eb13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e66eb13",
  null
  
)

export default component.exports